<template>
  <div class="sales-refund">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>售后退款</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="search">
      <el-input
        placeholder="商品名称"
        prefix-icon="el-icon-goods"
        size="small"
        v-model="searchForm.productName"
        clearable
        @keyup.enter.native="query"
      ></el-input>
      <el-input
        placeholder="退款编号"
        prefix-icon="el-icon-document"
        size="small"
        v-model="searchForm.refundNo"
        clearable
        @keyup.enter.native="query"
      ></el-input>
      <el-input
        placeholder="订单编号"
        prefix-icon="el-icon-tickets"
        size="small"
        v-model="searchForm.orderNo"
        clearable
        @keyup.enter.native="query"
      ></el-input>
      <el-select
        v-model="searchForm.refundStatus"
        placeholder="退款状态"
        size="small"
        clearable
      >
        <el-option
          v-for="item in refundStatusOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-date-picker
        v-model="searchForm.applyTimeRange"
        size="small"
        type="datetimerange"
        range-separator="至"
        start-placeholder="申请开始时间"
        end-placeholder="申请结束时间"
        value-format="yyyy-MM-dd HH:mm:ss"
      >
      </el-date-picker>
      <el-input
        placeholder="客户来源"
        prefix-icon="el-icon-connection"
        size="small"
        v-model="searchForm.customerSource"
        clearable
        @keyup.enter.native="query"
      ></el-input>
      <el-button type="primary" size="small" @click="query">搜索</el-button>
      <el-button size="small" @click="reset">重置</el-button>
      <el-button type="success" size="small" @click="exportData" :loading="exportLoading">
        {{ exportLoading ? '导出中...' : '导出' }}
      </el-button>
    </div>
    <div class="list">
      <el-table
        :data="refundList"
        style="width: 100%"
        :row-class-name="tableRowClassName"
        size="small"
        stripe
        border
        v-loading="listLoading"
      >
        <el-table-column prop="refund_no" label="退款编号" min-width="160" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="order_no" label="订单编号" min-width="160" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="product_name" label="商品名称" min-width="140" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="order_amount" label="订单金额(元)" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            ¥{{ formatPrice(scope.row.order_amount) }}
          </template>
        </el-table-column>
        <el-table-column prop="refund_amount" label="退款金额(元)" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            ¥{{ formatPrice(scope.row.refund_amount) }}
          </template>
        </el-table-column>
        <el-table-column prop="buyer_name" label="买家名称" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="refund_status" label="退款状态" align="center" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-tag :type="getRefundStatusType(scope.row.refund_status)" size="small">
              {{ getRefundStatusText(scope.row.refund_status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="apply_time" label="申请时间" min-width="165" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="initiator" label="发起人" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="customer_source" label="客户来源" align="center" show-overflow-tooltip></el-table-column>
      </el-table>
    </div>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pages"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SalesRefund',
  data() {
    return {
      searchForm: {
        productName: '',
        refundNo: '',
        orderNo: '',
        refundStatus: '',
        applyTimeRange: null,
        customerSource: ''
      },
      refundList: [],
      pages: 1,
      limit: 10,
      total: 0,
      listLoading: false,
      exportLoading: false,
      refundStatusOptions: []
    }
  },
  created() {
    this.fetchOrderEnums()
    this.getRefundList()
  },
  methods: {
    fetchOrderEnums() {
      this.$getOrderEnums().then((enums) => {
        this.refundStatusOptions = enums.refund_status || []
      })
    },
    getRefundList() {
      this.listLoading = true
      const { productName, refundNo, orderNo, refundStatus, applyTimeRange, customerSource } = this.searchForm
      let url = `/v1/admin/after-sales/list?page=${this.pages}&limit=${this.limit}`
      if (productName) url += `&product_name=${encodeURIComponent(productName)}`
      if (refundNo) url += `&refund_no=${encodeURIComponent(refundNo)}`
      if (orderNo) url += `&order_no=${encodeURIComponent(orderNo)}`
      if (refundStatus) url += `&refund_status=${encodeURIComponent(refundStatus)}`
      if (customerSource) url += `&customer_source=${encodeURIComponent(customerSource)}`
      if (applyTimeRange && applyTimeRange.length === 2) {
        url += `&apply_time_start=${encodeURIComponent(applyTimeRange[0])}&apply_time_end=${encodeURIComponent(applyTimeRange[1])}`
      }
      this.$get(url, {})
        .then((res) => {
          this.listLoading = false
          if (res.data && res.data.status === 'success' && res.data.data) {
            const d = res.data.data
            this.refundList = d.list || []
            this.total = d.total || 0
          } else {
            this.refundList = []
            this.total = 0
            this.$message.error((res.data && res.data.msg) || '请求失败')
          }
        })
        .catch(() => {
          this.listLoading = false
          this.refundList = []
          this.total = 0
        })
    },
    formatPrice(val) {
      if (val === undefined || val === null) return '0.00'
      const num = typeof val === 'number' ? val : parseFloat(val)
      if (isNaN(num)) return '0.00'
      return (num >= 100 ? num / 100 : num).toFixed(2)
    },
    getRefundStatusType(status) {
      const map = {
        PROCESSING: 'warning',
        SUCCESS: 'success',
        ABNORMAL: 'danger',
        CLOSED: 'info',
        NONE: 'info',
        pending: 'warning',
        approved: 'primary',
        refunded: 'success',
        rejected: 'danger',
        failed: 'info'
      }
      return map[status] || 'info'
    },
    getRefundStatusText(status) {
      const opt = (this.refundStatusOptions || []).find((o) => o.value === status)
      if (opt) return opt.label
      const fallback = {
        PROCESSING: '退款处理中',
        SUCCESS: '退款成功',
        ABNORMAL: '退款异常',
        CLOSED: '退款关闭',
        NONE: '无售后',
        pending: '待审核',
        approved: '审核通过',
        refunded: '已退款',
        rejected: '已拒绝',
        failed: '退款失败'
      }
      return fallback[status] || (status ? String(status) : '-')
    },
    tableRowClassName({ rowIndex }) {
      return rowIndex % 2 === 1 ? '' : 'success-row'
    },
    query() {
      this.pages = 1
      this.getRefundList()
    },
    reset() {
      this.searchForm = {
        productName: '',
        refundNo: '',
        orderNo: '',
        refundStatus: '',
        applyTimeRange: null,
        customerSource: ''
      }
      this.pages = 1
      this.getRefundList()
    },
    handleSizeChange(val) {
      this.limit = val
      this.getRefundList()
    },
    handleCurrentChange(val) {
      this.pages = val
      this.getRefundList()
    },
    exportData() {
      this.exportLoading = true
      const { productName, refundNo, orderNo, refundStatus, applyTimeRange, customerSource } = this.searchForm
      let url = `/v1/admin/after-sales/export?`
      if (productName) url += `&product_name=${encodeURIComponent(productName)}`
      if (refundNo) url += `&refund_no=${encodeURIComponent(refundNo)}`
      if (orderNo) url += `&order_no=${encodeURIComponent(orderNo)}`
      if (refundStatus) url += `&refund_status=${encodeURIComponent(refundStatus)}`
      if (customerSource) url += `&customer_source=${encodeURIComponent(customerSource)}`
      if (applyTimeRange && applyTimeRange.length === 2) {
        url += `&apply_time_start=${encodeURIComponent(applyTimeRange[0])}&apply_time_end=${encodeURIComponent(applyTimeRange[1])}`
      }
      url = url.replace(/\?&/, '?').replace(/\?$/, '') || '/v1/admin/after-sales/export'
      this.$getFile(url, {})
        .then((res) => {
          if (res && res.status === 200 && res.data) {
            const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
            const date = new Date()
            const timeStr = `${date.getFullYear()}${String(date.getMonth() + 1).padStart(2, '0')}${String(date.getDate()).padStart(2, '0')}${String(date.getHours()).padStart(2, '0')}${String(date.getMinutes()).padStart(2, '0')}${String(date.getSeconds()).padStart(2, '0')}`
            const a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = `售后列表_${timeStr}.xlsx`
            a.click()
            URL.revokeObjectURL(a.href)
            this.$message.success('导出成功')
          } else {
            this.$message.error('导出失败')
          }
        })
        .catch(() => {
          this.$message.error('导出失败')
        })
        .finally(() => {
          this.exportLoading = false
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
.sales-refund
  .search
    margin 20px 0
    display flex
    flex-wrap wrap
    align-items center
    gap 12px
    .el-input
      width 160px
    .el-select
      width 140px
    .el-date-editor
      width 360px
    .el-button
      margin-right 0

  .list
    margin-top 20px
    min-height 400px
    border 1px solid #EBEEF5

  .block
    margin-top 10px

  .el-table .success-row
    background #f0f9eb
</style>



// WEBPACK FOOTER //
// src/pages/OrderCenter/SalesRefund.vue